import { Button, ButtonGroup, Token } from '@chaser/components';
import { roleNames, roleDescriptions } from '@/util/constants';
import styles from './RoleCard.module.scss';

const RoleCard = ({ role, userCount, onViewUsers, onManageUsers, manageDisabled }) => (
  <div className={styles.card}>
    <div className={styles.header}>
      <span className={styles.name}>{roleNames[role]}</span>
      <Token
        size="narrow"
        backgroundColor="Light Neutral 2"
        borderColor="Mid Neutral 3"
        color="Dark Neutral 2"
      >
        {userCount} {userCount === 1 ? 'user' : 'users'}
      </Token>
    </div>
    <span className={styles.description}>{roleDescriptions[role]}</span>
    <ButtonGroup className={styles.actions}>
      <Button appearance="secondary" size="narrow" onClick={() => onViewUsers(role)}>
        View all users ({userCount})
      </Button>
      <Button
        appearance="secondary"
        size="narrow"
        disabled={manageDisabled}
        onClick={() => onManageUsers(role)}
      >
        Add or remove users
      </Button>
    </ButtonGroup>
  </div>
);

export default RoleCard;
